import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MIN_ENTROPY_BITS = 50;
export const LOGIN_PASSWORD_MIN_LENGTH = 6;

export function estimateEntropyBits(password: string): number {
  let charset = 0;
  if (/[a-z]/.test(password)) charset += 26;
  if (/[A-Z]/.test(password)) charset += 26;
  if (/\d/.test(password)) charset += 10;
  if (/[^a-zA-Z\d]/.test(password)) charset += 33;
  if (charset === 0) {
    return 0;
  }

  return password.length * Math.log2(charset);
}

export function entropyValidator(minEntropyBits: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = String(control.value ?? '');
    if (!password) {
      return null;
    }

    return estimateEntropyBits(password) >= minEntropyBits
      ? null
      : {
          weakEntropy: {
            minEntropyBits,
          },
        };
  };
}

export function passwordMatchValidator(
  passwordControlName = 'password',
  confirmPasswordControlName = 'confirmPassword',
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = String(control.get(passwordControlName)?.value ?? '');
    const confirmPassword = String(control.get(confirmPasswordControlName)?.value ?? '');

    if (!password && !confirmPassword) {
      return null;
    }

    if (password === confirmPassword) {
      return null;
    }

    return { passwordMismatch: true };
  };
}
